import { useState } from "react";
import LocalStorageService from "../common/services/LocalStorageService";

// The customer's choice between cards and rows, kept across visits and
// shared by every page that lists products.
const VIEW_KEY = "products_view";
const VIEWS = ["grid", "list"];

export default function useProductsView() {
  // Cards stay the default; anything else found in storage falls back to them.
  const [view, setView] = useState(() => {
    const stored = LocalStorageService?.get(VIEW_KEY);
    return VIEWS.includes(stored) ? stored : "grid";
  });

  // Only how the loaded products are drawn changes, so nothing is refetched
  // and the URL stays as it is.
  const onViewChange = (value) => {
    if (!VIEWS.includes(value)) {
      return;
    }
    setView(value);
    LocalStorageService?.set(VIEW_KEY, value);
  };

  return { view, isList: view === "list", onViewChange };
}
